import React from 'react';
import ButtonFilled from '../../components/button-filled';
import CircleExclamation from '../../assets/images/icons/circle-exclamation.svg'
import XMark from '../../assets/images/icons/xmark.svg'
import DotLoader from "react-spinners/DotLoader";

const WaitingLoaderHover = ({ isOpen, text }) => {
  return (
    <>
        {isOpen && (
            <div className='modal-hover-center'>
                {text}
                <DotLoader
                    color={'#6100FF'}
                    loading={true}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"></DotLoader>
            </div>
        )}
    </>
  );
};

export default WaitingLoaderHover;